import  { FC } from 'react';
import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Drawer, Theme, useMediaQuery } from '@mui/material';
import NavSection from './NavSection';
import useAuth from "../../auth/useAuth";
import {ROLE_ADMIN} from "../../auth/userAuthorities";
import * as React from "react";
import useOptimisedReports from "../../hooks/useOptimisedReports";

interface DashboardSidebarProps {
  onMobileClose: () => void;
  openMobile: boolean;
}

const getSections = (useOptimised: boolean): any[] => [
  {
    path: '/',
    title: 'Dashboard',
  },
  {
    path: '/brands',
    title: 'Brands',
  },
  {
    path: '/affiliates',
    title: 'Companies',
  },
  {
    path: '/deals',
    title: 'Affiliate Deals',
  },
  ...(!useOptimised ? [{
    path: '/links',
    title: 'Tracking Links',
  }] : []),
  ...(!useOptimised ? [{
    title: 'Events',
    items: [
      {
        path: '/events/clicks',
        title: 'Click Events',
      },
      {
        path: '/events/registrations',
        title: 'Registration Events',
      },
      {
        path: '/events/ftds',
        title: 'FTD Events',
      },
      {
        path: '/events/deposits',
        title: 'Deposit Events',
      },
    ],
  }] : []),
  {
    title: 'Reports',
    items: [
      {
        path: '/players',
        title: 'Players',
      },
      {
        path: '/organic-players',
        title: 'Organic Players',
      },
      ...(!useOptimised ? [{
        path: '/exclusions',
        title: 'Exclusions',
      }] : []),
      {
        path: '/affiliates-sources',
        title: 'Affiliate Sources',
      },
      {
        path: '/user-deals',
        title: 'Affiliate Deals',
      },
      {
        path: '/bulk-cohort',
        title: 'Bulk Cohort Report',
      },
      {
        path: '/affiliates-report',
        title: 'Companies',
      },
      {
        path: '/brands-report',
        title: 'Brands',
      },
      {
        path: '/tags-report',
        title: 'Tags',
      }
    ],
  },
  {
    path: '/contact-us-messages',
    title: 'Contact Messages',
  },
  {
    title: 'Settings',
    items: [
      {
        path: '/tags',
        title: 'Tags',
      },
      {
        path: '/operator-management',
        title: 'Operator Management',
        authorities: [ROLE_ADMIN],
      },
      {
        path: '/account',
        title: 'Account',
      },
      {
        path: '/testimonials',
        title: 'Testimonials',
      },
    ],
  },
  {
    title: 'Docs',
    items: [
      {
        path: '/docs/postback',
        title: 'Postback',
      }
    ],
  },
];

const DashboardSidebar = () => {
  const location = useLocation();
  const [openSection, setOpenSection] = useState<string | null>(null);
  const auth = useAuth();
  const [useOptimised] = useOptimisedReports();
  const sections = getSections(useOptimised);

  return (
      <Box sx={{ p: 2 }}>
        {sections.filter(section => {
          return section.authorities
              ? section.authorities.every(authority => auth.user?.authorities.includes(authority))
              : true;
        }).map((section) => (
            <NavSection
                key={section.title}
                open={section.title === openSection}
                toggleOpen={() => setOpenSection(section.title === openSection ? null : section.title)}
                pathname={location.pathname}
                sx={{
                  '& + &': {
                    mt: 1,
                  },
                  p: 0,
                }}
                {...section}
            />
        ))}
      </Box>
  );
};

export default DashboardSidebar;
